import React, { useState, useCallback } from "react";
import ReactHtmlParser from "@mediaspace/shared/ui/html-react-parser";
import { IconButton } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";
import {Alert24Icon, Clear24Icon} from "@kaltura/ds-react-icons";
import {translate} from "@mediaspace/shared/utils";

export interface BoardMessagesProps {
    boardMessages: {
        id: number;
        message: string;
        allowDismiss: boolean;
    }[];
    channelName: string;
    channelId: number;
}

const StyledBoardMessages = styled("ul")(({ theme }) => ({
    margin: theme.spacing(0),
    padding: theme.spacing(0),
    marginBottom: theme.spacing(2)
}));

const StyledMessageItem = styled("li")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    borderRadius: 4,
    backgroundColor: theme.kaltura.palette.tone7,
    fontSize: theme.typography.pxToRem(13),
    color: theme.kaltura.palette.tone3
}));

const StyledIcon = styled(Alert24Icon)(({ theme }) => ({
    marginRight: theme.spacing(1)
}));

const StyledMessageText = styled("div")({
    flexGrow: 1
});

const CHANNEL_NAME_PATTERN = "{CHANNEL_NAME}";

/**
 *  Channel message board - display list of messages
 */
const BoardMessages = (props: BoardMessagesProps) => {

    const { boardMessages, channelName, channelId } = props;

    const getMessagesToHide = useCallback((channelId: number) => {
        return JSON.parse(
            localStorage.getItem("channelBoardMessages_" + channelId) || "[]"
        );
    },[]);

    const [hideMessages, setHideMessages] = useState<number[]>(
        getMessagesToHide(channelId)
    );

    const handleHide = (messageId: number) => {
        const messagesToHide = JSON.parse(
            localStorage.getItem("channelBoardMessages_" + channelId) || "[]"
        );
        messagesToHide.push(messageId);
        localStorage.setItem(
            "channelBoardMessages_" + channelId,
            JSON.stringify(messagesToHide)
        );
        setHideMessages(messagesToHide);
    };
    return (
        <StyledBoardMessages className={"kms-ds-channel-page-board-messages"}>
            {boardMessages.map((boardMessage) => {
                if (hideMessages.indexOf(boardMessage.id) >= 0) {
                    return null;
                }
                const message = boardMessage.message.replace(
                    CHANNEL_NAME_PATTERN,
                    channelName
                );

                return (
                    <StyledMessageItem
                        className={`board-message alert-info`}
                        key={"board-message-" + boardMessage.id}
                    >
                        <StyledIcon />
                        <StyledMessageText className={"kms-ds-channel-page-board-messages-text"}>
                            {ReactHtmlParser(message)}
                        </StyledMessageText>
                        {boardMessage.allowDismiss && (
                            <IconButton
                                tabIndex={0}
                                aria-label={translate("Close")}
                                onClick={() => handleHide(boardMessage.id)}
                            >
                                <Clear24Icon />
                            </IconButton>
                        )}
                    </StyledMessageItem>
                );
            })}
        </StyledBoardMessages>
    );
};

export default BoardMessages;
